"use client";

import Link from "next/link";
import type { Id } from "@convex/_generated/dataModel";
import { Pencil } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { adminListingHref } from "./use-listing-admin-access";

export function ListingAdminEditButton({
  productId,
}: {
  productId: Id<"products">;
}) {
  return (
    <Button
      asChild
      variant="ink"
      size="sm"
      className="relative rounded-md max-md:size-8 max-md:px-0 max-md:before:absolute max-md:before:-inset-1.5 max-md:before:content-['']"
    >
      <Link
        href={adminListingHref(productId)}
        title="Edit in admin"
        onClick={(event) => event.stopPropagation()}
      >
        <Pencil className="size-4 max-md:size-3.5" aria-hidden="true" />
        <span className="max-md:sr-only">Edit in admin</span>
      </Link>
    </Button>
  );
}
